<template>
  <div>
    <div v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
        </div>

        <div class="col-xs-12">
          <div class="info-box download">
            <a target="_blank" href="assets/files/ekop_2025_palyazati_felhivas.pdf" title="Pályázati felhívás letöltés">
              <span class="highlight">Pályázati felhívás</span> letöltés
            </a>
          </div>
        </div>

        <div class="col-xs-12">
          <h5 style="margin-top: 0px;" class="form-block-title">
            Pályázat választás
          </h5>
          <comboboxV2 v-on:onChange="osztondijValtoztat" label="Pályázott ösztöndíj" name="osztondij_id" :errors="errors" id="osztondij_id" :options="palyazhato_osztondijak" v-model="form.values.osztondij_id" />
        </div>

        <template v-if="form.values.osztondij_id != ''">
          <div class="col-xs-12">
            <h5 class="form-block-title">
              Hallgató alapadatok
            </h5>
          </div>
          <div class="col-xs-6">
            <inputbox label="Név" :errors="errors" id="nev" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+" v-model="form.hallgato_alapadatok.nev"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Születési hely, idő" :errors="errors" id="szulhelyido" name="szulhelyido" v-model="form.hallgato_alapadatok.szulhelyido"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Neptunkód" :errors="errors" regexp_filter="[a-zA-Z0-9]+" id="neptunkod" name="neptunkod" v-model="form.hallgato_alapadatok.neptunkod"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Email cím" :errors="errors" id="email" name="email" regexp_filter="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" v-model="form.hallgato_alapadatok.email"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Mobilszám" :errors="errors" id="mobilszam" name="mobilszam" regexp_filter="[+0-9 /-]+" v-model="form.hallgato_alapadatok.mobilszam"/>
          </div>
          <div class="col-xs-6">
            <comboboxV2 v-show="karLatszik()" :errors="errors" label="Kar" id="kar" name="kar" :options="karok" v-model="form.hallgato_alapadatok.kar"/>
            <comboboxV2 v-show="doktoriIskolaLatszik()" :errors="errors" label="Doktori Iskola" id="doktori_iskola" name="doktori_iskola" :options="doktori_iskolak" v-model="form.hallgato_alapadatok.doktori_iskola"/>
          </div>
          <div class="col-xs-6" v-show="szakLatszik()">
            <inputbox regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\-\,]+" label="Szak" :errors="errors" id="szak" name="szak" v-model="form.hallgato_alapadatok.szak"/>
          </div>
          <div class="col-xs-6" v-show="tanszekLatszik()">
            <inputbox regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .\-\,]+" label="Tanszék" :errors="errors" id="tanszek" name="tanszek" v-model="form.hallgato_alapadatok.tanszek"/>
          </div>

          <!-- Pályázati alapdatok -->

          <div class="col-xs-12">
            <h5 class="form-block-title">
              Pályázat alapadatok
            </h5>
          </div>
          <div class="col-xs-6">
            <comboboxV2 label="Pályázott ösztöndíjas jogviszony időtartama" name="jogviszony_idotartam" id="jogviszony_idotartam" :options="jogviszonyidotartamok" v-model="form.values.jogviszony_idotartam" />
          </div>
          <div class="col-xs-6">
            <comboboxV2 label="ÚNKP Ösztöndíjban részesültem" name="unkp_reszesult_e" id="unkp_reszesult_e" :options="igen_nem" v-model="form.values.unkp_reszesult_e" />
          </div>
          <div class="col-xs-6">
            <inputbox label="Kutatási/művészeti téma címe" :errors="errors" id="tema_cim" name="tema_cim" v-model="form.values.tema_cim"/>
          </div>
          <div class="col-xs-6">
            <comboboxV2 @onChange="tudomanyAgak(true)" label="Kutatási/művészeti téma tudományterületi besorolása" id="tudomanyterulet" name="tudomanyterulet" :options="tudomanyteruletek" v-model="form.values.tudomanyterulet"/>
          </div>
          <div class="col-xs-6">
            <comboboxV2 label="Kutatási/művészeti téma tudományági besorolása" id="tudomanyag" name="tudomanyag" :options="tudomanyagak" v-model="form.values.tudomanyag"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Témavezető neve" :errors="errors" id="temavezeto_neve" name="temavezeto_neve" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .-]+" v-model="form.values.temavezeto_neve"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Témavezető e-mail címe" :errors="errors" id="temavezeto_email" name="temavezeto_email" regexp_filter="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" v-model="form.values.temavezeto_email"/>
          </div>
          <div class="col-xs-6">
            <inputbox label="Témavezető mobilszáma" :errors="errors" id="temavezeto_mobil" name="temavezeto_mobil" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" v-model="form.values.temavezeto_mobil"/>
          </div>
          <div class="col-xs-12" v-show="ABTudomanyosPublikacioSzerzojeLatszik()">
            <comboboxV2 tooltipDescription="’Igen’ válasz esetén kérjük a publikáció(ka)t feltölteni a „A pályázó teljesítményét alátámasztó dokumentumok” pontban." label="Scimago Journal Ranking szerinti Q1/Q2 és/vagy a Magyar Tudományos Akadémia tudományos osztályai által “A” vagy “B” kategóriába sorolt folyóiratokban megjelent tudományos publikáció szerzője" name="a_b_tudomanyos_publikacio_szerzoje" id="a_b_tudomanyos_publikacio_szerzoje" :options="igen_nem" v-model="form.values.a_b_tudomanyos_publikacio_szerzoje" />
          </div>
          <div class="col-xs-12" v-show="proScientiaLatszik()">
            <comboboxV2 @onChange="() => { $refs.pro_scientia_arte_igazolas.deleteFiles(); }" label="Az Országos Tudományos Diákköri Tanács által adományozott Pro Scientia/Arte Aranyérem kitüntetésben részesült VAGY az Országos Tudományos Diákköri Konferencián (OTDK) elért I. II. vagy III. helyezéssel rendelkezik." name="pro_scientia_arte_reszvetel" id="pro_scientia_arte_reszvetel" :options="igen_nem" v-model="form.values.pro_scientia_arte_reszvetel" />
          </div>
          <div class="col-xs-12" v-show="tmdkLatszik()">
            <comboboxV2 label="Pályázó az elmúlt 5 évben rendelkezik TMDK/szakdolgozat/diplomamunka témavezetéssel" id="tmdk_reszvetel" :options="igen_nem" v-model="form.values.tmdk_reszvetel" />
          </div>
          <div class="col-xs-12" v-show="kutatocsoportEgyuttmukodesLatszik()">
            <comboboxV2 @onChange="() => { $refs.kutatocsoport_egyuttmukodes_igazolas.deleteFiles(); }" label="Kutatócsoporttal együttműködés" name="kutatocsoport_egyuttmukodes" id="kutatocsoport_egyuttmukodes" :options="igen_nem" v-model="form.values.kutatocsoport_egyuttmukodes" />
          </div>

          <!-- Dokumentumok -->

          <div class="col-xs-12">
            <h5 class="form-block-title">
              Dokumentumok
            </h5>
          </div>

          <div class="col-xs-12">
            <div class="info-box download">
              <a target="_blank" href="assets/files/kutatasi_terv_ekop_2025.docx" title="Kutatási terv letöltés">
                <span class="highlight">Kutatási terv</span> letöltés
              </a>
            </div>
            <div class="info-box download">
              <a target="_blank" href="assets/files/palyazati_adatlap_ekop_2025.xlsx" title="Pályázati adatlap letöltés">
                <span class="highlight">Pályázati adatlap</span> letöltés
              </a>
            </div>
            <div class="info-box download">
              <a target="_blank" href="assets/files/palyazoi_nyilatkozat_ekop_2025.docx" title="Pályázói nyilatkozat letöltés">
                <span class="highlight">Pályázói nyilatkozat</span> letöltés
              </a>
            </div>
            <div class="info-box download">
              <a target="_blank" href="assets/files/temavezetoi_nyilatkozat_ekop_2025.docx" title="Témavezetői nyilatkozat letöltés">
                <span class="highlight">Témavezetői nyilatkozat</span> letöltés
              </a>
            </div>
            <div class="info-box download">
              <a target="_blank" href="assets/files/tudomanyagi_kepzesi_besorolas_ekop_2025.docx" title="Tudományági besorolás letöltés">
                <span class="highlight">Tudományági besorolás</span> letöltés
              </a>
            </div>
            <div class="info-box download">
              <a target="_blank" href="assets/files/felsooktatasi_intezmeny_szandeknyilatkozata_ekop_2025.docx" title="Széchenyi István Egyetem szándéknyilatkozata a kutatás befogadásáról letöltés">
                <span class="highlight">Széchenyi István Egyetem szándéknyilatkozata a kutatás befogadásáról</span> letöltés
              </a>
            </div>
          </div>

          <div v-show="form.values.pro_scientia_arte_reszvetel == 'igen'" class="col-xs-12">
            <UploadHandler ref="pro_scientia_arte_igazolas" max_uploaded_files="10" v-on:change="(value) => { changeValue(value, 'pro_scientia_arte_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="pro_scientia_arte_igazolas" label="Pro Scientia/Arte Aranyérem vagy OTDK I., II., III. helyezés igazolása" name="pro_scientia_arte_igazolas" :loaded_files="form.values.pro_scientia_arte_igazolas"/>
          </div>
          <div v-show="form.values.kutatocsoport_egyuttmukodes == 'igen'" class="col-xs-12">
            <UploadHandler ref="kutatocsoport_egyuttmukodes_igazolas" max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'kutatocsoport_egyuttmukodes_igazolas'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="kutatocsoport_egyuttmukodes_igazolas" label="Kutatócsoporttal együttműködés igazolás" name="kutatocsoport_egyuttmukodes_igazolas" :loaded_files="form.values.kutatocsoport_egyuttmukodes_igazolas"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'palyazati_adatlap'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="palyazati_adatlap" label="Kitöltött, aláírt pályázati adatlap" name="palyazati_adatlap" :loaded_files="form.values.palyazati_adatlap"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'palyazati_adatlap_szerkesztheto'); }" accepted_files="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :errors="errors" id="palyazati_adatlap_szerkesztheto" label="Kitöltött pályázati adatlap szerkeszthető (Excel fájl)" name="palyazati_adatlap_szerkesztheto" :loaded_files="form.values.palyazati_adatlap_szerkesztheto"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'alairt_kutatasi_terv'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="alairt_kutatasi_terv" label="Aláírt kutatási terv (témavezető és pályázó által aláírva)" name="alairt_kutatasi_terv" :loaded_files="form.values.alairt_kutatasi_terv"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'alairt_palyazoi_nyilatkozat'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="alairt_palyazoi_nyilatkozat" label="Aláírt pályázói nyilatkozat" name="alairt_palyazoi_nyilatkozat" :loaded_files="form.values.alairt_palyazoi_nyilatkozat"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'alairt_intezmenyi_fogado_nyilatkozat'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="alairt_intezmenyi_fogado_nyilatkozat" label="Aláírt intézményi fogadó nyilatkozat" name="alairt_intezmenyi_fogado_nyilatkozat" :loaded_files="form.values.alairt_intezmenyi_fogado_nyilatkozat"/>
          </div>
          <div v-show="kitoltottAlairtTemavezetoiNyilatkozatLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'kitoltott_alairt_temavezetoi_nyilatkozat'); }" accepted_files="image/jpeg,application/pdf" :errors="errors" id="kitoltott_alairt_temavezetoi_nyilatkozat" label="Kitöltött, aláírt témavezetői nyilatkozat" name="kitoltott_alairt_temavezetoi_nyilatkozat" :loaded_files="form.values.kitoltott_alairt_temavezetoi_nyilatkozat"/>
          </div>

          <div v-show="tanulmanyiEredmenyIgazolasLatszik()" class="col-xs-12">
            <UploadHandler max_uploaded_files="1" ref="tanulmanyi_eredmeny_igazolas" v-on:change="(value) => { changeValue(value, 'tanulmanyi_eredmeny_igazolas'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="tanulmanyi_eredmeny_igazolas" :label="tanulmanyiEredmenyIgazolasLabel()" name="tanulmanyi_eredmeny_igazolas" :loaded_files="form.values.tanulmanyi_eredmeny_igazolas"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="100" v-on:change="(value) => { changeValue(value, 'palyazo_teljesitmeny_igazolas'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="palyazo_teljesitmeny_igazolas" label="A pályázó teljesítményét alátámasztó dokumentumok (amennyiben a pályázó rendelkezésére áll, pl. publikációs lista, konferencia részvételt, kiállítást igazoló dokumentumok, további tudományos teljesítmény dokumentációja, szakmai-közösségi tevékenység, kutatásokban, kutatási terepmunkában való részvétének igazolása, tudományos ismeretterjesztő/tudomány népszerűsítő tevékenység dokumentációja, egyéb szakmai (tudományos és oktatási) tevékenységet bemutató dokumentáció, versenyeredmények." name="palyazo_teljesitmeny_igazolas" :loaded_files="form.values.palyazo_teljesitmeny_igazolas"/>
          </div>
          <div v-show="nyelvtudastIgazoloDokumentumLatszik()" class="col-xs-12">
            <UploadHandler ref="nyelvtudast_igazolo_dokumentum" max_uploaded_files="20" v-on:change="(value) => { changeValue(value, 'nyelvtudast_igazolo_dokumentum'); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="nyelvtudast_igazolo_dokumentum" label="Nyelvtudást igazoló dokumentum" name="nyelvtudast_igazolo_dokumentum" :loaded_files="form.values.nyelvtudast_igazolo_dokumentum"/>
          </div>
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'hallgatoi_munkaltatoi_jogviszonyigazolas'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="hallgatoi_munkaltatoi_jogviszonyigazolas" label="Hallgatói/munkáltatói jogviszonyigazolás Tanulmányi Osztály / Doktori Iskola / Humánerőforrás Osztály által hitelesítve. Ennek hiányában a pályázó által írt és aláírt nyilatkozat, hogy 2025. szeptember 1-ig AKTÍV hallgatói jogviszonya keletkezik VAGY fiatal oktató, kutató kategóriákban a 2025. szeptember 1. - 2026. augusztus 31. közötti oktatói, kutatói munkavégzésre irányuló jogviszonya, vagy munkavégzésre irányuló egyéb jogviszonya legkésőbb 2025. szeptember 1. napjáig várhatóan létrejön." name="hallgatoi_munkaltatoi_jogviszonyigazolas" :loaded_files="form.values.hallgatoi_munkaltatoi_jogviszonyigazolas"/>
          </div>
          <div v-show="abszolutoriumMegszerzesetIgazoloDokumentum()" class="col-xs-12">
            <UploadHandler ref="abszolutorium_megszerzeset_igazolo_dokumentum" max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'abszolutorium_megszerzeset_igazolo_dokumentum'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="abszolutorium_megszerzeset_igazolo_dokumentum" label="Az abszolutórium megszerzését igazoló dokumentum elektronikusan VAGY PhD/DLA fokozat megszerzését igazoló dokumentum (amennyiben a pályázat benyújtásakor a fokozatot megszerezte)" name="abszolutorium_megszerzeset_igazolo_dokumentum" :loaded_files="form.values.abszolutorium_megszerzeset_igazolo_dokumentum"/>
          </div>
          <div v-show="felviHuJelentkezesiAdatlapLatszik()" class="col-xs-12">
            <UploadHandler ref="felvi_hu_jelentkezesi_adatlap" max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'felvi_hu_jelentkezesi_adatlap'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="felvi_hu_jelentkezesi_adatlap" label="Felvi.hu felületéről generálható felvételi jelentkezési adatlap" name="felvi_hu_jelentkezesi_adatlap" :loaded_files="form.values.felvi_hu_jelentkezesi_adatlap"/>
          </div>
          <div v-show="nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik()" class="col-xs-12">
            <UploadHandler ref="nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve" max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve" label="Nyilatkozat felvételi jelentkezésről illetékes Doktori Iskola ügyintézője által hitelesítve. (A nyilatkozatot a pályázó készíti el, arra vonatkozóan, hogy melyik doktori iskolába adta be felvételi jelentkezését.)" name="nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve" :loaded_files="form.values.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve"/>
          </div>
          <div v-show="form.values.tmdk_reszvetel == 'igen'" class="col-xs-12">
            <UploadHandler ref="tmdk_temavezetes_igazolas" max_uploaded_files="1" v-on:change="(value) => { changeValue(value, 'tmdk_temavezetes_igazolas'); }" accepted_files="application/pdf,application/x-pdf" :errors="errors" id="tmdk_temavezetes_igazolas" label="TMDK témavezetés igazolása (Egyetemi Tudományos és Művészeti Diákköri Tanács által) ÉS/VAGY szakdolgozat/diplomamunka témavezetés igazolása felettes vezető által" name="tmdk_temavezetes_igazolas" :loaded_files="form.values.tmdk_temavezetes_igazolas"/>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="nyilatkozat_elfogadasa" name="nyilatkozat_elfogadasa" type="checkbox" value="1" v-model="nyilatkozat_elfogadasa"/>
                <label for="nyilatkozat_elfogadasa">
                  <div class="icon"></div>
                  <div>
                    Jelen pályázati anyagom benyújtásával egyidejűleg kijelentem, hogy nyertes pályázatom esetén az Egyetemi Kutató Ösztöndíj Program ösztöndíjas jogviszony létesítésekor igazolom az ösztöndíjszerződés létesítéséhez, valamint az ösztöndíjas jogviszony fenntartásához szükséges <strong><u>AKTÍV</u> hallgatói jogviszonyomat/ munkaviszonyomat vagy munkavégzésre irányuló egyéb jogviszonyomat</strong>, és vállalom, hogy ezt az ösztöndíjas jogviszony teljes időtartama alatt mindvégig fenntartom.
                  </div>
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozat_elfogadasa'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="save(0)" :disabled="!save_enabled" type="button" name="kuld" class="button">Mentés</button>
              <button v-on:click="save(1)" :disabled="!save_enabled" type="button" name="kuld" class="button">Véglegesít</button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="fill_info != ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
          <div class="article-text" v-html="fill_info"></div>

          <div v-if="remedy">
            <div style="margin-top: 30px;" class="info-box warning">
              Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.
            </div>
            <a href="javascript:void(0)" title="" v-on:click="remedy_popup = true;" class="button">Fellebezés</a>
          </div>

          <div style="margin-top: 40px;" class="info-box" v-if="remedy_user != false">
            <div class="title">Fellebezés</div>
            <div><span class="highlight">{{ remedy_user.name }}</span> ({{remedy_user.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_user.msg)">
            </div>
          </div>

          <div style="margin-top: 20px;" class="info-box" v-if="remedy_admin != false">
            <div class="title">Fellebezés válasz</div>
            <div><span class="highlight">{{ remedy_admin.name }}</span> ({{remedy_admin.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_admin.msg)">
            </div>
          </div>

        </div>
      </div>
    </div>
    <Fellebezes v-on:close="(final) => { remedy_popup = false; if (final) remedy = false; }" v-if="remedy && $route.query.id != undefined && remedy_popup" :form_id="$route.query.id"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Fellebezes from './fellebezes.vue';
import moment from 'moment';

export default {
  components: {
    Fellebezes
  },
  data: function() {
    return {
      igen_nem:[{value:'igen',label:'Igen'},{value:'nem',label:'Nem'}],
      palyazhato_osztondijak:[{value:'',label:'- válasszon -',group:''},{value:'25_1_1',label_short:'EKÖP-25-1-I',label:'Felsőoktatási Alapképzés Egyetemi Kutatói Ösztöndíj Program (leendő felsőbb éves)'},{value:'25_1_2',label_short:'EKÖP-25-1-II',label:'Felsőoktatási Alapképzés Egyetemi Kutatói Ösztöndíj Program (leendő első éves)'},{value:'25_2_1',label_short:'EKÖP-25-2-I',label:'Felsőoktatási Mesterképzés Egyetemi Kutatói Ösztöndíj Program (leendő felsőbb éves)'},{value:'25_2_2',label_short:'EKÖP-25-2-II',label:'Felsőoktatási Mesterképzés Egyetemi Kutatói Ösztöndíj Program (leendő első éves)'},{value:'25_3_1',label_short:'EKÖP-25-3-I',label:'Felsőoktatási Doktori Egyetemi Kutatói Ösztöndíj Program'},{value:'25_4_1',label_short:'EKÖP-25-4-I',label:'Felsőoktatási Fiatal Oktató, Kutató Egyetemi Kutatói Ösztöndíj Program (Doktorvárományos)'},{value:'25_4_2',label_short:'EKÖP-25-4-II',label:'Felsőoktatási Fiatal Oktató, Kutató Egyetemi Kutatói Ösztöndíj Program (Posztdoktor)'}],karok:[{value:'Audi Hungaria Járműmérnöki Kar',label:'Audi Hungaria Járműmérnöki Kar'},{value:'Apáczai Csere János Pedagógiai, Humán- és Társadalomtudományi Kar',label:'Apáczai Csere János Pedagógiai, Humán- és Társadalomtudományi Kar'},{value:'Albert Kázmér Mosonmagyaróvári Kar',label:'Albert Kázmér Mosonmagyaróvári Kar'},{value:'Deák Ferenc Állam- és Jogtudományi Kar',label:'Deák Ferenc Állam- és Jogtudományi Kar'},{value:'Egészség- és Sporttudományi Kar',label:'Egészség- és Sporttudományi Kar'},{value:'Építész-, Építő- és Közlekedésmérnöki Kar',label:'Építész-, Építő- és Közlekedésmérnöki Kar'},{value:'Gépészmérnöki, Informatikai és Villamosmérnöki Kar',label:'Gépészmérnöki, Informatikai és Villamosmérnöki Kar'},{value:'Kautz Gyula Gazdaságtudományi Kar',label:'Kautz Gyula Gazdaságtudományi Kar'},{value:'Művészeti Kar',label:'Művészeti Kar'}],doktori_iskolak:[{value:'Wittmann Antal Növény-, Állat- és Élelmiszer- tudományi Multidiszciplináris Doktori Iskola',label:'Wittmann Antal Növény-, Állat- és Élelmiszer- tudományi Multidiszciplináris Doktori Iskola'},{value:'Regionális- és Gazdaságtudományi Doktori Iskola',label:'Regionális- és Gazdaságtudományi Doktori Iskola'},{value:'Állam- és Jogtudományi Doktori Iskola',label:'Állam- és Jogtudományi Doktori Iskola'},{value:'Multidiszciplináris Műszaki Tudományi Doktori Iskola',label:'Multidiszciplináris Műszaki Tudományi Doktori Iskola'}],tudomanyteruletek:[{value:'agrártudományok',label:'Agrártudományok',tudomanyagak:[{value:'állatorvosi tudományok',label:'Állatorvosi tudományok'},{value:'állattenyésztési tudományok',label:'Állattenyésztési tudományok'},{value:'élelmiszertudományok',label:'Élelmiszertudományok'},{value:'erdészeti és vadgazdálkodási tudományok',label:'Erdészeti és vadgazdálkodási tudományok'},{value:'növénytermesztési és kertészeti tudományok',label:'Növénytermesztési és kertészeti tudományok'}]},{value:'bölcsészettudományok',label:'Bölcsészettudományok',tudomanyagak:[{value:'filozófiai tudományok',label:'Filozófiai tudományok'},{value:'irodalom- és kultúratudományok',label:'Irodalom- és kultúratudományok'},{value:'művészettörténeti és művelődéstörténeti tudományok',label:'Művészettörténeti és művelődéstörténeti tudományok'},{value:'művészettudomány',label:'Művészettudomány'},{value:'néprajz- és kulturális antropológia',label:'Néprajz- és kulturális antropológia'},{value:'neveléstudományok',label:'Neveléstudományok'},{value:'nyelvtudományok',label:'Nyelvtudományok'},{value:'pszichológiai tudományok',label:'Pszichológiai tudományok'},{value:'történelemtudományok',label:'Történelemtudományok'},{value:'vallástudományok',label:'Vallástudományok'}]},{value:'hittudományok',label:'Hittudományok',tudomanyagak:[{value:'hittudományok',label:'Hittudományok'}]},{value:'műszaki tudományok',label:'Műszaki tudományok',tudomanyagak:[{value:'agrárműszaki tudományok',label:'Agrárműszaki tudományok'},{value:'anyagtudományok és technológiák',label:'Anyagtudományok és technológiák'},{value:'bio-, környezet- és vegyészmérnöki tudományok',label:'Bio-, környezet- és vegyészmérnöki tudományok'},{value:'építészmérnöki tudományok',label:'Építészmérnöki tudományok'},{value:'építőmérnöki tudományok',label:'Építőmérnöki tudományok'},{value:'gépészeti tudományok',label:'Gépészeti tudományok'},{value:'informatikai tudományok',label:'Informatikai tudományok'},{value:'katonai műszaki tudományok',label:'Katonai műszaki tudományok'},{value:'közlekedés- és járműtudományok',label:'Közlekedés- és járműtudományok'},{value:'villamosmérnöki tudományok',label:'Villamosmérnöki tudományok'}]},{value:'művészetek',label:'Művészetek',tudomanyagak:[{value:'építőművészet',label:'Építőművészet'},{value:'film- és videoművészet',label:'Film- és videoművészet'},{value:'iparművészet',label:'Iparművészet'},{value:'képzőművészet',label:'Képzőművészet'},{value:'multimédia-művészet',label:'Multimédia-művészet'},{value:'színházművészet',label:'Színházművészet'},{value:'tánc- és mozdulatművészet',label:'Tánc- és mozdulatművészet'},{value:'zeneművészet',label:'Zeneművészet'}]},{value:'orvostudományok',label:'Orvostudományok',tudomanyagak:[{value:'egészségtudományok',label:'Egészségtudományok'},{value:'elméleti orvostudományok',label:'Elméleti orvostudományok'},{value:'gyógyszerészeti tudományok',label:'Gyógyszerészeti tudományok'},{value:'klinikai orvostudományok',label:'Klinikai orvostudományok'},{value:'sporttudományok',label:'Sporttudományok'}]},{value:'társadalomtudományok',label:'Társadalomtudományok',tudomanyagak:[{value:'állam- és jogtudományok',label:'Állam- és jogtudományok'},{value:'gazdálkodás- és szervezéstudományok',label:'Gazdálkodás- és szervezéstudományok'},{value:'hadtudományok',label:'Hadtudományok'},{value:'közgazdaságtudományok',label:'Közgazdaságtudományok'},{value:'közigazgatás-tudományok',label:'Közigazgatás-tudományok'},{value:'média-és kommunikációs tudományok',label:'Média-és kommunikációs tudományok'},{value:'politikatudományok',label:'Politikatudományok'},{value:'regionális tudományok',label:'Regionális tudományok'},{value:'rendészettudomány',label:'Rendészettudomány'},{value:'szociológiai tudományok',label:'Szociológiai tudományok'}]},{value:'természettudományok',label:'Természettudományok',tudomanyagak:[{value:'biológiai tudományok',label:'Biológiai tudományok'},{value:'fizikai tudományok',label:'Fizikai tudományok'},{value:'földtudományok',label:'Földtudományok'},{value:'kémiai tudományok',label:'Kémiai tudományok'},{value:'környezettudományok',label:'Környezettudományok'},{value:'matematika- és számítástudományok',label:'Matematika- és számítástudományok'}]}],
      jogviszonyidotartamok: [],
      tudomanyagak: [],
      fill_info: '',
      errors: [],
      save_enabled: false,
      remedy: false,
      remedy_popup: false,
      remedy_admin: false,
      remedy_user: false,
      nyilatkozat_elfogadasa: false,
      form: {
        id: 0,
        name: '',
        values: {
          palyazati_azonosito: '',
          osztondij: '',
          osztondij_id: '',
          jogviszony_idotartam: '5 hónap',
          unkp_reszesult_e: 'nem',
          tema_cim: '',
          tudomanyterulet: 'agrártudományok',
          tudomanyag: 'állatorvosi tudományok',
          temavezeto_neve: '',
          temavezeto_email: '',
          temavezeto_mobil: '',
          pro_scientia_arte_reszvetel: 'nem',
          pro_scientia_arte_igazolas: [],
          tmdk_reszvetel: 'nem',
          kutatocsoport_egyuttmukodes: 'nem',
          kutatocsoport_egyuttmukodes_igazolas: [],
          palyazati_adatlap: [],
          palyazati_adatlap_szerkesztheto: [],
          alairt_kutatasi_terv: [],
          alairt_palyazoi_nyilatkozat: [],
          alairt_intezmenyi_fogado_nyilatkozat: [],
          palyazo_teljesitmeny_igazolas: [],
          hallgatoi_munkaltatoi_jogviszonyigazolas: [],
          kitoltott_alairt_temavezetoi_nyilatkozat: [],
          tanulmanyi_eredmeny_igazolas: [],
          nyelvtudast_igazolo_dokumentum: [],
          abszolutorium_megszerzeset_igazolo_dokumentum: [],
          a_b_tudomanyos_publikacio_szerzoje: 'nem',
          felvi_hu_jelentkezesi_adatlap: [],
          nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve: [],
          tmdk_temavezetes_igazolas: []
        },
        hallgato_alapadatok: {
          nev: '',
          szulhelyido: '',
          neptunkod: '',
          email: '',
          mobilszam: '',
          kar: '',
          doktori_iskola: '',
          szak: '',
          tanszek: '',
        }
      }
    }
  },
  watch: {
    'form.values.osztondij_id': function() {
      var _this = this;

      this.palyazhato_osztondijak.map(function(po) {
        if (po.value == _this.form.values.osztondij_id)
          _this.form.values.osztondij = po.label;
      });
    }
  },
  mounted: function() {
    this.kitoltesLekerdezes();
  },
  methods: {
    kitoltesLekerdezes: function() {
      var _this = this;

      this.$root.ajax('form/ekop2025_kitoltes_ellenorzes/'+this.$route.query.id, {
        success: function(response) {
          if (response.error) {
            swal('Hiba!',response.error,'error');

          } else {
            if (response.redirect_path != undefined) {
              _this.$router.push({path: response.redirect_path});
              return;
            }

            _this.fill_info = response.fill_info;
            _this.form.name = response.form_name;
            _this.remedy = response.remedy;

            if (response.remedy_admin != undefined)
              _this.remedy_admin = response.remedy_admin;

            if (response.remedy_user != undefined)
              _this.remedy_user = response.remedy_user;

            _this.form.hallgato_alapadatok.kar = _this.karok[0].value;

            if (!Array.isArray(response.hallgato_alapadatok))
              _this.form.hallgato_alapadatok = $.extend({}, _this.form.hallgato_alapadatok, response.hallgato_alapadatok);

            // Betöltött adat beállítása
            if (response.saved_data != undefined && response.saved_data != '') {
              _this.form.values = response.saved_data.values;

              _this.tudomanyAgak(false);
              _this.jogviszonyIdotartamOpciok();

            } else {
              _this.tudomanyAgak(true);
            }

            _this.save_enabled = true;
          }
        }
      });
    },

    jogviszonyIdotartamOpciok: function() {
      switch(this.form.values.osztondij_id) {
        case '25_1_1':
        case '25_1_2':
        case '25_2_1':
        case '25_2_2':
          this.jogviszonyidotartamok = [{value:'5 hónap',label:'5 hónap'},{value:'10 hónap',label:'10 hónap'}];
        break;
        case '25_3_1':
          this.jogviszonyidotartamok = [{value:'5 hónap',label:'5 hónap'},{value:'7 hónap',label:'7 hónap'},{value:'12 hónap',label:'12 hónap'}];
        break;
        case '25_4_1':
        case '25_4_2':
          this.jogviszonyidotartamok = [{value:'12 hónap',label:'12 hónap'}];
        break;
      }
    },

    abszolutoriumMegszerzesetIgazoloDokumentum: function() {
      return (['25_4_1', '25_4_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    nyilatkozatFelveteliJelentkezesrolIlletekesDoktoriIskolaUgyintezojeAltalHitelesitveLatszik: function() {
      return (['25_3_1'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    felviHuJelentkezesiAdatlapLatszik: function() {
      return (['25_1_2', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    ABTudomanyosPublikacioSzerzojeLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    proScientiaLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    kutatocsoportEgyuttmukodesLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    tudomanyAgak: function(ertek_beallitas) {
      var _this = this;

      this.tudomanyteruletek.map(function(tudomanyterulet) {
        if (tudomanyterulet.value == _this.form.values.tudomanyterulet)
          _this.tudomanyagak = tudomanyterulet.tudomanyagak;
      });

      if (ertek_beallitas)
        this.form.values.tudomanyag = this.tudomanyagak[0].value;
    },

    karLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2', '25_4_1', '25_4_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    doktoriIskolaLatszik: function() {
      return (['25_3_1'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    szakLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    tmdkLatszik: function() {
      return (['25_4_1', '25_4_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    tanszekLatszik: function() {
      return (['25_4_1', '25_4_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    tanulmanyiEredmenyIgazolasLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    tanulmanyiEredmenyIgazolasLabel: function() {
      if (['25_1_1', '25_1_2'].indexOf(this.form.values.osztondij_id) > -1) {
        return 'A tanulmányi eredményről szóló igazolás hiánytalanul, magyar nyelven kitöltve, Tanulmányi Osztály által hitelesítve VAGY leendő első éves alkategóriában középfokú képzésben teljesített utolsó 2 lezárt félév tanulmányi eredményéről bizonyítvány másolat';
      }

      if (['25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1) {
        return 'A tanulmányi eredményről szóló igazolás hiánytalanul, magyar nyelven kitöltve, Tanulmányi Osztály által hitelesítve VAGY leendő első éves osztatlan alkategóriában középfokú képzésben teljesített utolsó 2 lezárt félév tanulmányi eredményéről bizonyítvány másolat';
      }
    },

    nyelvtudastIgazoloDokumentumLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    kitoltottAlairtTemavezetoiNyilatkozatLatszik: function() {
      return (['25_1_1', '25_1_2', '25_2_1', '25_2_2', '25_3_1', '25_4_1'].indexOf(this.form.values.osztondij_id) > -1 ? true : false);
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];
      this.form.id = this.$route.query.id;

      this.$root.ajax('form/ekop2025_mentes/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          palyazhato_osztondijak: JSON.stringify(this.palyazhato_osztondijak),
          veglegesit: veglegesit,
          nyilatkozat_elfogadasa: this.nyilatkozat_elfogadasa
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    },

    changeValue: function(value, name) {
      this.form.values[name] = value;
    },

    osztondijValtoztat: function() {
      const _this = this;

      this.errors = [];

      this.form.hallgato_alapadatok.kar = '';
      this.form.hallgato_alapadatok.szak = '';
      this.form.hallgato_alapadatok.doktori_iskola = '';
      this.form.hallgato_alapadatok.tanszek = '';

      if (['25_1_1', '25_1_2', '25_2_1', '25_2_2', '25_4_1', '25_4_2'].indexOf(this.form.values.osztondij_id) > -1) {
        this.form.hallgato_alapadatok.kar = this.karok[0].value;
      }

      if (['25_3_1'].indexOf(this.form.values.osztondij_id) > -1) {
        this.form.hallgato_alapadatok.doktori_iskola = this.doktori_iskolak[0].value;
      }

      this.jogviszonyIdotartamOpciok();
      this.form.values.jogviszony_idotartam = this.jogviszonyidotartamok[0].value;

      this.form.values.a_b_tudomanyos_publikacio_szerzoje = 'nem';
      this.form.values.tmdk_reszvetel = 'nem';

      this.form.values.pro_scientia_arte_reszvetel = 'nem';
      this.form.values.pro_scientia_arte_igazolas = [];
      Vue.nextTick(() => {
        _this.$refs.pro_scientia_arte_igazolas.deleteFiles();
      });

      this.form.values.kutatocsoport_egyuttmukodes = 'nem';
      this.form.values.kutatocsoport_egyuttmukodes_igazolas = [];
      Vue.nextTick(() => {
        _this.$refs.kutatocsoport_egyuttmukodes_igazolas.deleteFiles();
      });

      this.form.values.tanulmanyi_eredmeny_igazolas = [];
      Vue.nextTick(() => {
        _this.$refs.tanulmanyi_eredmeny_igazolas.deleteFiles();
      });

      this.form.values.nyelvtudast_igazolo_dokumentum = [];
      Vue.nextTick(() => {
        _this.$refs.nyelvtudast_igazolo_dokumentum.deleteFiles();
      });

      this.form.values.abszolutorium_megszerzeset_igazolo_dokumentum = [];
      Vue.nextTick(() => {
        _this.$refs.abszolutorium_megszerzeset_igazolo_dokumentum.deleteFiles();
      });

      this.form.values.felvi_hu_jelentkezesi_adatlap = [];
      Vue.nextTick(() => {
        _this.$refs.felvi_hu_jelentkezesi_adatlap.deleteFiles();
      });

      this.form.values.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve = [];
      Vue.nextTick(() => {
        _this.$refs.nyilatkozat_felveteli_jelentkezesrol_illetekes_doktori_iskola_ugyintezoje_altal_hitelesitve.deleteFiles();
      });

      this.form.values.tmdk_temavezetes_igazolas = [];
      Vue.nextTick(() => {
        _this.$refs.tmdk_temavezetes_igazolas.deleteFiles();
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// ekop2025.vue?13b5ec2e